var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNad = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_15969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.2673C18.6274 24.2673 24 18.8948 24 12.2673C24 5.63992 18.6274 0.267334 12 0.267334C5.37258 0.267334 0 5.63992 0 12.2673C0 18.8948 5.37258 24.2673 12 24.2673Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51548 20.7533C4.01888 21.2567 4.55597 21.7057 5.11936 22.1009L21.8335 5.38669C21.4383 4.8233 20.9894 4.28621 20.486 3.78282C19.9826 3.27943 19.4455 2.83055 18.8821 2.4353L2.16797 19.1495C2.56317 19.7128 3.01209 20.25 3.51548 20.7533Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51428 3.7815C-0.271532 7.56731 -0.998282 13.2529 1.33248 17.7689L17.5016 1.5998C12.9856 -0.730968 7.3 -0.00412455 3.51428 3.7815Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4854 20.7508C24.2711 16.9651 24.9979 11.2795 22.6672 6.76343L6.49805 22.9326C11.014 25.2634 16.6996 24.5366 20.4854 20.7508Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91356 7.05013L8.56891 7.68262L9.28497 8.9849L7.82486 8.70562L7.6398 10.1805L6.6228 9.09571L5.60575 10.1805L5.42078 8.70562L3.96063 8.98485L4.67664 7.68257L3.33203 7.05013L4.67669 6.4176L3.96063 5.11541L5.42073 5.39469L5.6058 3.91968L6.6228 5.00455L7.63984 3.91968L7.82486 5.39469L9.28497 5.11541L8.569 6.41765L9.91356 7.05013Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_15969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNad);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/NAD.1ce6b3b3c3087859d8b2ca602c26173a.svg";